import React, { useState } from 'react'

import TextareaAutosize from 'react-textarea-autosize'
import { CirclePlus, LoaderCircle, X } from 'lucide-react'

import useToasterHelper from '../../../../helpers/ToasterHelper'
import helpers from '../../../../commonHelpers/helpers'
import FirebaseStorageService from '../../../../services/storageService'

import { CONST } from '../../../../const/const'
import { MESSAGES_CONST } from '../../../../const/messages-const'

interface IProps {
  questionId: string
  defaultValue?: string
  handleChange: (value: string) => void
  addFile: (url: string) => void
  files?: string[]
  removeFile: (val: string, index: number) => void
}

export const CommentsQuestion: React.FC<IProps> = ({
  handleChange,
  defaultValue,
  questionId,
  files,
  addFile,
  removeFile,
}) => {
  const toastFunctions = useToasterHelper()
  const [imgLoading, setImgLoading] = useState<boolean>(false)

  const addFileInner = async (event: any) => {
    const inputFiles = event.target.files
    const file = inputFiles[0]
    const PATH = CONST.DATA.STORAGE.USERS.ANSWERS_URL.PREFIX

    if (!file) return toastFunctions.info({ message: MESSAGES_CONST.NO_FILE_SELECTED })

    setImgLoading(true)

    try {
      const downloadUrl = await FirebaseStorageService.uploadFile(
        file,
        `${PATH}/${questionId}/${new Date().getTime()}`,
        (percent: number) => {
          if (0) console.log(percent)
        }
      )

      addFile(downloadUrl as string)
      toastFunctions.success({ message: MESSAGES_CONST.FILE_UPLOADED })
    } catch (error) {
      toastFunctions.error({ message: MESSAGES_CONST.SOMETHING_WENT_WRONG })
      helpers.logger({
        isError: true,
        message: error,
      })
    } finally {
      setImgLoading(false)
    }
  }

  return (
    <div className="w-full flex flex-col">
      <TextareaAutosize
        defaultValue={defaultValue || ''}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={'Enter Answer....'}
        className="w-full outline-none !focus:outline-none rounded border-black/20 focus-visible:border-black"
        style={{ boxShadow: 'none' }}
      />
      <div className="flex gap-3 mt-5">
        {files?.map((file, index) => {
          return (
            <div key={index} className="relative group">
              <img
                className="w-[45px] h-[45px] rounded-lg border border-SeabiscuitLightThemeColorD3 object-cover"
                src={file}
                alt=""
              />
              <button
                disabled={imgLoading}
                className="hidden group-hover:flex group-hover:bg-black/20 items-center justify-center absolute z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-5 h-5 border border-solid border-white rounded-full p-[2px]"
                onClick={() => removeFile(file, index)}
              >
                <X className="text-white w-full h-full" />
              </button>
            </div>
          )
        })}
        {imgLoading && (
          <div className="flex justify-center items-center w-[45px] h-[45px] rounded-lg border-SeabiscuitLightThemeColorD3 border bg-white">
            <LoaderCircle className="animate-spin" />
          </div>
        )}
        {!imgLoading && (
          <label className="cursor-pointer group flex items-center gap-3">
            <div className="flex items-center justify-center w-[45px] h-[45px] rounded-md bg-black/5">
              <CirclePlus className="text-black w-5 h-5 group-hover:scale-110 transition-all" />
              <input
                type="file"
                name="fileImage"
                accept=".jpeg, .png, .jpg"
                onChange={(e: any) => addFileInner(e)}
                className="absolute cursor-pointer h-full w-full opacity-0 left-0 right-0 top-0 bottom-0 -z-10"
              />
            </div>
            <span className="text-sm text-black/50">Add file</span>
          </label>
        )}
      </div>
    </div>
  )
}
